<!-- 朋友圈任务 -->
<template>
  <div>
    <div class="head-title">朋友圈任务</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业可以统一创建发布到客户的朋友圈的内容，员工在企业微信端会收到企业通知，然后点击发表按钮就可以把相应内容发布到客户朋友圈。
            <a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=145"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
          <p>
            2、企业管理者可以在任务列表点击完成情况，查看员工的完成结果统计。
          </p>

        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建任务</el-button
          >
        </div>
        <div class="menu-right">
          <div>
            <el-date-picker
              v-model="time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="pickerOptions"
              @change="getData"
              style="width:50.0rem"
            >
            </el-date-picker>
          </div>
          <div style="margin-left: 2.4rem">
            <el-select
              clearable
              class="menu-select"
              style="width: 27.0rem"
              v-model="type"
              placeholder="请选择类型"
              @change="changeType"
            >
              <el-option
                v-for="item in typeData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div>
            <el-input
              clearable
              prefix-icon="el-icon-search"
              style="width: 35.0rem; margin: 0 .0rem 0 2.0rem"
              placeholder="请输入内容搜索"
              v-model="q"
              @change="onSearch"
            >
            <el-button slot="append" type="primary" @click="onSearch"
              >查询</el-button
            >
            </el-input>

          </div>
        </div>
      </div>
      <div class="main">
        <el-table
          ref="multipleTable"

          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; margin-top: 2.0rem"
          border
          v-loading="loading"
        >
          <el-table-column
            prop="task_name"
            label="任务名称"
            style="width:10%"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="visible_range" label="发送范围" style="width:10%">
          </el-table-column>
          <el-table-column prop="user_list_name" label="发送成员" style="width:10%">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <span
                    v-for="(item, index) in scope.row.user_list_name"
                    :key="index"
                  >
                    {{ item }}
                    <span
                      style="margin: 0 .4rem"
                      v-if="index + 1 < scope.row.user_list_name.length"
                      >，</span
                    >
                  </span>
                </div>
                <div>
                  <el-tag
                    size="mini"
                    style="margin: .2rem"
                    v-for="(item, index) in scope.row.user_list_name"
                    :key="index"
                    >{{ item }}</el-tag
                  >
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="department_list_name" label="发送部门" style="width:10%">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="(item, index) in scope.row.department_list_name"
                :key="index"
                >{{ item }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="tag_list_name" label="" style="width:10%">
            <template slot="header">
              <div>客户可见范围</div>
            </template>
            <template slot-scope="scope">
              <el-tag
                size="mini"
                style="margin: .2rem"
                v-for="(item, index) in scope.row.tag_list_name"
                :key="index"
                >{{ item }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容" show-overflow-tooltip style="width:10%">
          </el-table-column>
          <el-table-column prop="url_list" label="素材/封面" style="width:10%">
            <template slot-scope="scope">
              <template v-if="scope.row.type == '图片'">
                <el-image
                  v-for="(i, index) of scope.row.url_list"
                  :key="index"
                  style="width: 4.0rem; height: 4.0rem; margin: .2rem"
                  :preview-src-list="scope.row.url_list"
                  :src="i"
                  fit="scale-down"
                ></el-image>
              </template>
              <template v-else-if="scope.row.type == '链接'">
                <div class="link-container">
                  <el-image
                    style="
                      width: 4.0rem;
                      height: 4.0rem;
                      float: left;
                      margin-right: 1.0rem;
                    "
                    v-for="(item, index) in scope.row.url_list"
                    :src="`${item}`"
                    :preview-src-list="scope.row.url_list"
                    :key="index"
                    fit="cover"
                  ></el-image>
                  <a
                    :href="scope.row.link_url"
                    class="el-link el-link--primary is-underline"
                    :title="scope.row.link_url"
                    target="_blank"
                    >{{ scope.row.link_title }}</a
                  >
                </div>
              </template>
              <template v-else-if="scope.row.type == '视频'">
                <video
                  v-for="(i, index) of scope.row.url_list"
                  :key="index"
                  style="width: 20.0rem; height: 11.2rem"
                  controls
                  :src="i"
                ></video>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            style="width:10%"
          ></el-table-column>
          <el-table-column prop="create_time" label="创建时间" style="width:10%">
          </el-table-column>
          <el-table-column label="操作"  fixed="right"  width="170">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleStatistics(scope.row.id)"
                >完成情况</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getData"
        />
      </div>
    </div>
    <el-dialog title="完成情况" center :visible.sync="dialogVisible">
      <div>
        <el-table

          tooltip-effect="dark"
          style="width: 100%"
          :data="tableList"
          border
        >
          <el-table-column prop="user_avatar" label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 5.0rem; height: 5.0rem"
                :src="scope.row.user_avatar"
                :preview-src-list="[scope.row.user_avatar]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="user_name" label="姓名"> </el-table-column>
          <el-table-column
            prop="publish_status_name"
            label="完成情况(24小时内)"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.publish_status == 0" style="color: #f56c6c">
                {{ scope.row.publish_status_name }}
              </span>
              <span
                v-else-if="scope.row.publish_status == 1"
                style="color: #67c23a"
              >
                {{ scope.row.publish_status_name }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="totalList"
        :page.sync="listQueryList.page"
        :limit.sync="listQueryList.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getList"
      />
      <div slot="footer">
        <el-button type="default" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      tableData: [],
      module: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableList: [],
      totalList: 0,
      listQueryList: {
        page: 1,
        limit: 20,
      },
      dialogVisible: false,
      type: "",
      typeData: [
        {
          value: "",
          label: "请选择类型",
        },
        {
          value: "视频",
          label: "视频",
        },
        {
          value: "图片",
          label: "图片",
        },
        {
          value: "链接",
          label: "链接",
        },
      ],
      q: "",
      time: [],
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              end.setTime(end.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      listid : 0,
      taskId: null
    };
  },

  computed: {},

  mounted() {
    this.getData();
  },

  methods: {
    onAdd() {
      this.$router.push({
        name: "clientFriendTaskDetail",
      });
    },
    async getData() {
      let start_time = "";
      let end_time = "";
      if (this.time !== null && this.time.length) {
        start_time = parseInt(this.time[0].getTime() / 1000);
        end_time = parseInt(this.time[1].getTime() / 1000);
      }

      const params = {
        phone: this.tooken.phone,
        usertoken: this.tooken.usertoken,
        account_id: this.tooken.account_id,
        page: this.listQuery.page,
        number_page:this.listQuery.limit,
        type: this.type,
        content: this.q,
        start_time,
        end_time,
      };
      this.loading = true;
      const { data: res } = await this.axios({
        url: "/crm/FriendsTask/getCrete",
        method: "POST",
        data: this.qs.stringify(params),
      });

      if (res.code == 1) {
        this.total = res.count;
        res.data.data.forEach((i) => {
          i.user_list_name2 = i.user_list_name.toString();
        });
        this.tableData = res.data.data;
        this.total= res.data.total;
      }
      this.loading = false;
    },
    async getList() {
      try {
        const { data: res } = await this.axios({
          url: "/crm/FriendsTask/friendTaskList",
          method: "POST",
          data: this.qs.stringify({
            phone: this.tooken.phone,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            page: this.listQueryList.page,
            number_page:this.listQueryList.limit,
            task_id: this.taskId,
          }),
        });
        if (res.code == 1) {
          this.tableList = res.data.data;
          this.totalList = res.data.total;
          console.log(this.tableList,'lsittable')
        }
      } catch (error) {
        console.log(error);
      }
    },
    changeType() {
      this.getData();
    },
    onSearch() {
      this.getData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    handleStatistics(id) {
      this.dialogVisible = true;
      this.taskId = id;
      this.getList();


    },
  },
};
</script>
<style lang="scss"  scoped>
.header-menu {
  display: flex;
  justify-content: space-between;
  .menu-right {
    display: flex;
  }
}
.link-container {
  background: rgb(236, 236, 236);
  padding: .6rem;
  overflow: hidden;
}
.el-link {
  display: inline;
}
.el-button--text{padding-left:.0rem !important;}
</style>
